import { render, staticRenderFns } from "./ResetPass2.vue?vue&type=template&id=b309796c&scoped=true&"
import script from "./ResetPass2.vue?vue&type=script&lang=js&"
export * from "./ResetPass2.vue?vue&type=script&lang=js&"
import style0 from "./ResetPass2.vue?vue&type=style&index=0&id=b309796c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b309796c",
  null
  
)

export default component.exports